/*
 * @Description: 项目人员管理
 * @Date: 2025-07-16 15:29:41
 */
import { route } from './src/router';

const name = 'project-person-manage';
export { name, route };
